export enum TIPO_IMOVEL {
	RESIDENCIAL = 1,
	COMERCIAL = 2,
	TERRENO = 3
}
